var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tilled-card-list"},[_c('list',{ref:"tilledCardList",attrs:{"fs":_vm.tilledCardFields,"api":"EzTimePay/cards","editLink":_vm.editLink,"title":"Cards","beforeDelete":_vm.handleBeforeDelete}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }